import { render, staticRenderFns } from "./passwordChange.vue?vue&type=template&id=4c8b6f85&scoped=true&"
import script from "./passwordChange.vue?vue&type=script&lang=js&"
export * from "./passwordChange.vue?vue&type=script&lang=js&"
import style0 from "./passwordChange.vue?vue&type=style&index=0&id=4c8b6f85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b6f85",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCardText,VIcon})
